import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useReservation } from '../../context';

export function ModalDelete() {
  const {
    isDeleteModalOpen,
    selectedReservation,
    closeDeleteModal,
    handleDeleteReservation,
  } = useReservation();

  if (!selectedReservation) return null;

  return (
    <Dialog
      open={isDeleteModalOpen}
      onClose={closeDeleteModal}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Confirmar Exclusão</DialogTitle>
      <DialogContent>
        <Typography>
          Tem certeza que deseja excluir a reserva{' '}
          <strong>{selectedReservation.name}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Esta ação não pode ser desfeita.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDeleteModal} variant="outlined">
          Cancelar
        </Button>
        <Button
          onClick={handleDeleteReservation}
          variant="contained"
          color="error"
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}